import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { tStatic } from "../lib/i18n";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6f6f6]">
        <div className="text-[#747474] text-sm">{tStatic("common.loading")}</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/app/dashboard" replace />;
  return children;
}
